export const HOME = { link: '' };
export const CREATESTICKER = { name: 'menu_item_create_stickers', link: 'create-sticker' };
export const ABOUTUS = { name: 'menu_item_about_us', link: 'about_us' };
export const IOS = { name: 'menu_item_ios', link: 'ios' };
export const ANDROID = { name: 'menu_item_android', link: 'android' };
export const PRIVACY = { name: 'Terms, Condition, and Privacy', link: 'terms_condition_privacy' };
export const FREQUENTLYASKEDQUESTION = { name: 'menu_item_faq', link: 'FAQ' };
export const SUPPORT = { name: 'menu_item_support', link: 'support'};
export const STICKERGUIDE = { name: 'menu_item_sticker_guide', link: 'sticker-guide' };
export const IMAGEFORMATS = { name: 'menu_item_image_formats', link: 'image-formats' }; 
